<template>
  <van-overlay :show="show && isLogin" @click="onClick" :z-index="13">
    <div class="balance-tips">
      <!-- :style="`width:${balanceWidth * 1.75}px`" -->
      <div class="top">
        <div class="line-top">
          <span class="text-left">CASH</span>
          <span class="text-right"
            >{{ formatMoney(balance.cash) }} {{ unitConversion(balance.currencyAlias) }}</span
          >
        </div>
        <div class="line-bottom">
          <div
            :class="$route && $route.name.includes('deposit') ? 'deposit-btn' : 'withdraw-btn'"
            @click="onDeposit"
          >
            Deposit
          </div>
          <div style="width: 0.2rem" />
          <div
            :class="$route && $route.name.includes('withdraw') ? 'deposit-btn' : 'withdraw-btn'"
            @click="onWithdraw"
          >
            Withdraw
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="left">
          <span class="text-line-1">BONUS</span>
          <span class="text-line-2">{{ formatMoney(balance.bonus) }}</span>
          <div class="use-bonus-btn" @click="onUseBonus">{{ $t('message.useBonus') }}</div>
        </div>
        <div class="right">
          <span class="text-line-1">VPS</span>
          <span class="text-line-2">{{ formatMoney(Math.round(balance.vps * 100) / 100) }}</span>
          <div class="use-vps-btn" @click="onUseVps">{{ $t('message.useVps') }}</div>
          <!-- <div class="use-vps-btn"></div> -->
        </div>
      </div>
      <!-- <p>CASH:</p>
            <p style="color: #ffddac">
                {{ formatMoney(balance.cash) }} {{ unitConversion(balance.currencyAlias) }}
            </p>
            <p>BONUS:</p>
            <p style="color: #ffddac">
                {{ formatMoney(balance.bonus) }}
            </p>
            <p>VPS:</p>
            <p style="color: #ffddac">{{ Math.floor(balance.bps) }}</p> -->
    </div>
  </van-overlay>
</template>

<script>
import { Key, setLocalStorage } from '@/common/localStorage'
import { useUserStore } from '@/stores/user'
import { formatMoney, unitConversion } from '@/utils/helper'
import { mapState } from 'pinia'

export default {
  name: 'balanceTips',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    balanceWidth: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState(useUserStore, ['balance', 'isLogin', 'country'])
  },
  methods: {
    formatMoney,
    unitConversion,
    onClick() {
      this.$emit('hide')
    },
    onDeposit() {
      console.log('onDeposit')
      if (this.country == 'CI') {
        this.$router.replace('/depositci')
      } else if (this.country == 'KE') {
        this.$router.replace('/depositke')
      } else if (this.country == 'TZ') {
        this.$router.replace('/deposittz')
      } else if (this.country == 'GH') {
        this.$router.replace('/depositgh')
      } else {
        this.$router.replace('/deposit')
      }
    },
    onWithdraw() {
      if (this.country == 'ET') {
        this.$router.replace('/withdrawet')
      } else if (this.country == 'GH') {
        this.$router.replace('/withdrawgh')
      } else if (this.country == 'TZ') {
        this.$router.replace('/withdrawtz')
      } else {
        this.$router.replace('/withdraw')
      }
    },
    onUseBonus() {
      setLocalStorage(Key.ShowBonusTips, true)
      this.$router.replace('/bonus')
    },
    onUseVps() {
      this.$router.replace('/vpsexchange')
    }
  }
}
</script>
<style lang="scss" scoped>
.balance-tips {
  position: absolute;
  top: 0.7rem;
  right: 0.25rem;
  padding: 0.2rem;
  background-color: #000;
  border-radius: 0.15rem;
  width: 5.14rem;

  p {
    font-size: 0.3rem;
    color: #fff;
    line-height: 0.1rem;
  }

  .top {
    display: flex;
    flex-direction: column;
    align-content: center;
    width: 5.14rem;
    height: 1.5rem;
    background: #000;
    border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
    border: 0.01rem solid #aa884a;

    .line-top {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.2rem;

      .text-left {
        height: 0.21rem;
        font-family: DroidSans;
        font-size: 0.3rem;
        color: #ffffff;
        line-height: 0.3rem;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-left: 0.2rem;
      }

      .text-right {
        height: 0.38rem;
        font-family: Oswald_Bold;
        font-weight: bold;
        font-size: 0.42rem;
        color: #ffddac;
        line-height: 0.4rem;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-right: 0.2rem;
      }
    }

    .line-bottom {
      display: flex;
      justify-content: center;
      margin-top: 0.2rem;

      .deposit-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2.05rem;
        height: 0.5rem;
        background: #aa884a;
        border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;

        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.24rem;
        color: #ffffff;
        line-height: NaNrem;
        text-align: left;
        font-style: normal;
        text-transform: none;
        // margin-right: 0.1rem;
      }

      .withdraw-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2.05rem;
        height: 0.5rem;
        background: #000000;
        border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
        border: 0.02rem solid #aa884a;

        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.24rem;
        color: #aa884a;
        line-height: NaNrem;
        text-align: left;
        font-style: normal;
        text-transform: none;
        // margin-left: 0.1rem;
      }
    }
  }

  .bottom {
    display: flex;
    justify-content: space-between;
    margin-top: 0.2rem;
    width: 5.14rem;

    .left {
      display: flex;
      flex-direction: column;
      width: 2.45rem;
      height: 1.6rem;
      background: #000;
      border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
      border: 0.01rem solid #aa884a;

      .text-line-1 {
        width: 0.75rem;
        // height: 0.56rem;
        font-family: DroidSans;
        font-size: 0.24rem;
        color: #ffffff;
        line-height: 0.3rem;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-top: 0.2rem;
        margin-left: 0.2rem;
      }

      .text-line-2 {
        width: 0.75rem;
        // height: 0.56rem;
        font-family: Oswald_Bold;
        font-size: 0.28rem;
        color: #ffffff;
        line-height: 0.3rem;
        text-align: left;
        font-style: normal;
        text-transform: none;
        font-weight: bold;
        margin-left: 0.2rem;
      }

      .use-bonus-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2.05rem;
        height: 0.49rem;
        background: #000000;
        border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
        border: 0.02rem solid #aa884a;
        margin-left: 0.2rem;
        margin-top: 0.15rem;

        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.24rem;
        color: #aa884a;
        line-height: NaNrem;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }

    .right {
      display: flex;
      flex-direction: column;
      width: 2.45rem;
      height: 1.6rem;
      background: #000;
      border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
      border: 0.01rem solid #aa884a;

      .text-line-1 {
        width: 0.75rem;
        // height: 0.56rem;
        font-family: DroidSans;
        font-size: 0.24rem;
        color: #ffffff;
        line-height: 0.3rem;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-top: 0.2rem;
        margin-left: 0.2rem;
      }

      .text-line-2 {
        width: 0.75rem;
        font-family: Oswald_Bold;
        font-size: 0.28rem;
        color: #ffffff;
        line-height: 0.3rem;
        text-align: left;
        font-style: normal;
        text-transform: none;
        font-weight: bold;
        margin-left: 0.2rem;
      }

      .use-vps-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2.05rem;
        height: 0.49rem;
        background: #000000;
        border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
        border: 0.02rem solid #aa884a;

        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.24rem;
        color: #aa884a;
        line-height: NaNrem;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-left: 0.2rem;
        margin-top: 0.15rem;
      }
    }
  }
}
</style>
